"use client";

import { Decorative } from "@faire/design-tokens";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";

export const OrderedCount = ({
  orderedCountMessage,
}: {
  orderedCountMessage?: string;
}) => {
  if (!orderedCountMessage) {
    return null;
  }
  return (
    <Typography
      variant="paragraphSansRegular"
      data-test-id="ordered-count-message"
      color={Decorative.shade.orange}
      maxLines={2}
    >
      {orderedCountMessage}
    </Typography>
  );
};
